
import { lazy } from 'react';
import { RouteConfig } from './types';

const CallReport = lazy(() => import('@/pages/reports/CallReport'));
const SystemLog = lazy(() => import('@/pages/reports/SystemLog'));
const AllUserActivity = lazy(() => import('@/pages/reports/AllUserActivity'));
const Documentation = lazy(() => import('@/pages/reports/Documentation'));
const UserActivityDashboard = lazy(() => import('@/pages/UserActivityDashboard'));

export const reportRoutes: RouteConfig[] = [
  {
    path: '/app/reports/calls',
    element: CallReport,
    requiresLayout: true,
    requiredPermissions: ['reports_calls.read']
  },
  {
    path: '/app/reports/all-activity',
    element: AllUserActivity,
    requiresLayout: true,
    requiredPermissions: ['reports_all_activity.read']
  },
  {
    path: '/app/reports/system-log',
    element: SystemLog,
    requiresLayout: true,
    requiredPermissions: ['reports_system_log.read']
  },
  {
    path: '/app/reports/documentation',
    element: Documentation,
    requiresLayout: true,
    requiredPermissions: ['reports_documentation.read']
  },
  {
    path: '/app/user-activity',
    element: UserActivityDashboard,
    requiresLayout: true,
    requiredPermissions: ['user_activity.read']
  }
];
